import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ArrowPathIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const Slide02Problem: React.FC = () => {
  const problems = [
    {
      icon: ClockIcon,
      title: 'Delayed Feedback',
      description: 'Parents wait months for quarterly reports to learn their child is struggling',
      color: '#ef4444',
    },
    {
      icon: ArrowPathIcon,
      title: 'Fragmented Systems',
      description: 'Teachers juggle multiple platforms, losing time on admin instead of teaching',
      color: '#f59e0b',
    },
    {
      icon: ChartBarIcon,
      title: 'One-Size-Fits-All',
      description: 'Students forced to move at the same pace, regardless of individual needs',
      color: '#8b5cf6',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-16 text-center"
      >
        The Problem with Traditional Education
      </motion.h2>

      <div className="flex gap-12">
        {problems.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 + index * 0.15 }}
            className="flex flex-col items-center text-center max-w-[280px]"
          >
            <div
              className="w-20 h-20 rounded-2xl flex items-center justify-center mb-6"
              style={{
                background: `${item.color}20`,
                border: `2px solid ${item.color}50`,
              }}
            >
              <item.icon className="w-10 h-10" style={{ color: item.color }} />
            </div>
            <h3 className="text-2xl font-semibold text-white mb-3">{item.title}</h3>
            <p className="text-lg text-[#94a3b8] leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Slide02Problem;
